module.exports = __webpack_public_path__ + "static/img/14000477.700f5194.png";